import React, { useState, useMemo, useCallback } from 'react';
import styles from './ListViewPage.module.sass';
import PinRed from './pin_red.png';
import PinGrey from './pin_grey.png';
import BookmarkGrey from './bookmark_grey.png';
import BookmarkGreen from './bookmark_green.png';
import { RedButton } from '../../commonComponents/RedButton/RedButton';
import useFindWeeklyPlans from '../../../hooks/useFindWeeklyPlans';
import { Empty } from 'antd';

import { useDispatch, useSelector } from 'react-redux';

import useUserTeams from '../../../hooks/useUserTeam';
import {
  createHomework,
  deleteHomework,
  deleteWeeklyPlan,
  deleteWeeklyPlanByFolderId,
  createWeeklyPlanByFolderId,
  unhideWeeklyPlan,
} from '../../../api/api';
import { addHomework, removeHomework } from '../../../Redux/listViewReducer';
import { hasWeeklyPlanPermission } from '../../../utils/utils';
import useMyWeeklyPlan from '../../../hooks/useMyWeeklyPlan';
import { ModalAssignment } from '../ModalAssignment';
import { EyeFilled } from '@ant-design/icons';

const HiddenList = ({ data }) => {
  const { refetchWeeklyPlans } = useFindWeeklyPlans();

  const [selectedItem, setSelectedItem] = useState(null);

  const { playerData } = useSelector((state) => state.playerDataReducer);

  const { data: weeklyPlanData, isLoading, refetchMyWeeklyPlan } = useMyWeeklyPlan(playerData.id);

  const checkSavedWeeklyPlan = useCallback(
    (folderId) => {
      return weeklyPlanData.some((item) => item?.folderId === folderId);
    },
    [weeklyPlanData],
  );

  const { manageTeams } = useUserTeams();

  const { data: listData } = useSelector((state) => state.listViewReducer);

  const homeworkData = useMemo(() => {
    const allHomework = listData
      ?.find((item) => item.actionType === 'SET_MY_HOMEWORK_DATA')
      .children.map((item) => item.children[0].children)
      .flat();

    // Use reduce to filter out duplicate entries based on title and subTitle
    const uniqueHomework = allHomework.reduce((acc, current) => {
      const duplicate = acc.find(
        (item) => item?.title === current?.title && item?.subTitle === current?.subTitle,
      );
      if (!duplicate) {
        return [...acc, current];
      }
      return acc;
    }, []);

    return uniqueHomework;
  }, [listData]);

  const dispatch = useDispatch();

  const checkHomework = useCallback(
    (_item) => {
      const homeworkCheck = homeworkData.some((item) => {
        if (item?.subTitle !== '') {
          return item.subTitle === _item.subTitle;
        } else {
          return item.title === _item.title;
        }
      });

      return homeworkCheck;
    },
    [homeworkData, manageTeams],
  );

  const checkHomeworkWithTeam = useCallback(
    (team, _item) => {
      const teamData = listData
        ?.find((item) => item.actionType === 'SET_MY_HOMEWORK_DATA')
        ?.children.find((item) => item.actionType === `cat-${team.id}`)?.children[0].children;

      const homeworkCheck = teamData?.some((item) => {
        if (item?.subTitle !== '') {
          return item.subTitle === _item.subTitle;
        } else {
          return item.title === _item.title;
        }
      });

      return homeworkCheck;
    },
    [data],
  );

  const onSubmit = useCallback(
    async (teams) => {
      // Remove homework from teams that have been unchecked
      const teamsToRemoveHomework = manageTeams.filter(
        (team) =>
          checkHomeworkWithTeam(team, selectedItem) &&
          !teams.some((selectedTeam) => selectedTeam.id === team.id),
      );

      for (const team of teamsToRemoveHomework) {
        await deleteHomework({ ...selectedItem, team }).then((res) => {
          console.info(res.msg);
          dispatch(removeHomework(selectedItem, team));
        });
      }

      // Add homework to newly selected teams
      for (const team of teams) {
        if (!checkHomeworkWithTeam(team, selectedItem)) {
          const newSelectedItem = {
            ...selectedItem,
            teamId: team.id,
          };

          if (!selectedItem.actionType) {
            newSelectedItem.folderId = selectedItem.id;
          }

          await createHomework(newSelectedItem).then((res) => {
            console.info(res.success);
            dispatch(addHomework(newSelectedItem, team));
          });
        }
      }

      setSelectedItem(null);
    },
    [checkHomeworkWithTeam, selectedItem, dispatch, manageTeams],
  );

  const handleDelete = useCallback((item) => {
    deleteWeeklyPlan(item.id).then((res) => {
      console.log(res);
      refetchWeeklyPlans();
    });
  }, []);

  const handleToggleBookmark = useCallback(
    async (folderId) => {
      const isSaved = checkSavedWeeklyPlan(folderId);
      if (isSaved) {
        await deleteWeeklyPlanByFolderId(playerData.id, folderId);
        refetchMyWeeklyPlan();
      } else {
        await createWeeklyPlanByFolderId(playerData.id, folderId);
        refetchMyWeeklyPlan();
      }
    },
    [checkSavedWeeklyPlan, refetchMyWeeklyPlan],
  );

  const handleHideWeeklyPlan = (folderId) => {
    unhideWeeklyPlan(folderId, playerData.id).then((res) => {
      console.log(res);
      refetchWeeklyPlans();
    });
  };

  return (
    <div className={styles.videoCluster}>
      {data?.length > 0 ? (
        <ul>
          {data
            .filter((folder) => folder?.hiddenWeeklyPlanForPlayer?.includes(playerData.id))
            .map((folder) => {
              return (
                <li key={folder.id} className={styles.listRow}>
                  <div className={styles.listRow}>
                    <div className={styles.listItem}>
                      <img
                        className={styles.pin}
                        src={checkSavedWeeklyPlan(folder.id) ? BookmarkGreen : BookmarkGrey}
                        style={{ cursor: 'pointer' }}
                        onClick={() => handleToggleBookmark(folder.id)}
                      />

                      {hasWeeklyPlanPermission(playerData.id) && (
                        <img
                          className={styles.pin}
                          src={checkHomework(folder) ? PinRed : PinGrey}
                          style={{ cursor: 'pointer' }}
                          onClick={() => setSelectedItem(folder)}
                        />
                      )}
                      {/* <Link
                      to={{
                        pathname: `/my-training-sessions/${folder.id}`,
                      }}
                      className={styles.textListItem}
                    > */}
                      <div className={styles.textListItem}>{folder.title}</div>
                      {/* </Link> */}
                    </div>
                    <div className={styles.bookmarkColumn}>
                      <>
                        <div className={styles.eyeContainer}>
                          <EyeFilled
                            onClick={() => handleHideWeeklyPlan(folder.id)}
                            className={styles.eye}
                          />
                        </div>
                        {hasWeeklyPlanPermission(playerData.id) && (
                          <RedButton
                            handleButtonClick={() => handleDelete(folder)}
                            className={styles.button}
                          >
                            Delete
                          </RedButton>
                        )}
                      </>
                    </div>
                  </div>
                </li>
              );
            })}
        </ul>
      ) : (
        <Empty description="No Training Session" />
      )}
      {selectedItem && (
        <ModalAssignment
          manageTeams={manageTeams}
          onClose={() => setSelectedItem(null)}
          onSubmit={onSubmit}
          selectedItem={selectedItem}
        />
      )}
    </div>
  );
};

export default HiddenList;
